import { render, staticRenderFns } from "./saldo.vue?vue&type=template&id=5472e2fc&scoped=true&"
import script from "./saldo.js?vue&type=script&lang=js&"
export * from "./saldo.js?vue&type=script&lang=js&"
import style0 from "./saldo.scss?vue&type=style&index=0&id=5472e2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472e2fc",
  null
  
)

export default component.exports